import React, { useState } from 'react';
import { Breadcrumb, Typography, Space } from 'antd';
import { HomeOutlined, ShoppingCartOutlined } from '@ant-design/icons';
import OrderList from '../components/Orders/OrderList';
import OrderSummary from '../components/Orders/OrderSummary';

const OrdersPage = () => {
    const [dateRange, setDateRange] = useState({ startDate: null, endDate: null });

    return (
        <div>
            <Breadcrumb
                style={{ marginBottom: '16px' }}
                items={[
                    {
                        href: '/',
                        title: <HomeOutlined />,
                    },
                    {
                        title: (
                            <Space>
                                <ShoppingCartOutlined />
                                <span>Orders</span>
                            </Space>
                        ),
                    },
                ]}
            />

            <div style={{ marginBottom: '24px' }}>
                <Typography.Title level={2}>Orders</Typography.Title>
            </div>

            <OrderSummary onFilterChange={setDateRange} />
            <OrderList dateRange={dateRange} />
        </div>
    );
};

export default OrdersPage;
